import React, { useEffect, useState } from "react";
import { getPublishedMembershipPlanCardItems, unpublishMembershipPlan } from "../helper/api";
import Toast from "../../../lib/toast";
import "../style.scss";

const RemoveIcon = () => (
  <svg width="16" height="16" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.3125 14.0625H19.6875C19.9361 14.0625 20.1746 14.1613 20.3504 14.3371C20.5262 14.5129 20.625 14.7514 20.625 15C20.625 15.2486 20.5262 15.4871 20.3504 15.6629C20.1746 15.8387 19.9361 15.9375 19.6875 15.9375H10.3125C10.0639 15.9375 9.8254 15.8387 9.64959 15.6629C9.47377 15.4871 9.375 15.2486 9.375 15C9.375 14.7514 9.47377 14.5129 9.64959 14.3371C9.8254 14.1613 10.0639 14.0625 10.3125 14.0625Z" fill="currentColor" />
    <path d="M15 26.25C16.4774 26.25 17.9403 25.959 19.3052 25.3936C20.6701 24.8283 21.9103 23.9996 22.955 22.955C23.9996 21.9103 24.8283 20.6701 25.3936 19.3052C25.959 17.9403 26.25 16.4774 26.25 15C26.25 13.5226 25.959 12.0597 25.3936 10.6948C24.8283 9.3299 23.9996 8.08971 22.955 7.04505C21.9103 6.00039 20.6701 5.17172 19.3052 4.60636C17.9403 4.04099 16.4774 3.75 15 3.75C12.0163 3.75 9.15483 4.93526 7.04505 7.04505C4.93526 9.15483 3.75 12.0163 3.75 15C3.75 17.9837 4.93526 20.8452 7.04505 22.955C9.15483 25.0647 12.0163 26.25 15 26.25ZM15 28.125C11.519 28.125 8.18064 26.7422 5.71922 24.2808C3.25781 21.8194 1.875 18.481 1.875 15C1.875 11.519 3.25781 8.18064 5.71922 5.71922C8.18064 3.25781 11.519 1.875 15 1.875C18.481 1.875 21.8194 3.25781 24.2808 5.71922C26.7422 8.18064 28.125 11.519 28.125 15C28.125 18.481 26.7422 21.8194 24.2808 24.2808C21.8194 26.7422 18.481 28.125 15 28.125Z" fill="currentColor" />
  </svg>
);

const CardIcon = () => (
  <svg width="26" height="26" viewBox="0 0 171 171" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M28.5 89.6111V102.493C28.5 103.586 28.956 104.59 29.868 105.507C30.78 106.424 31.7846 106.88 32.8819 106.875H138.118C139.211 106.875 140.215 106.419 141.132 105.507C142.049 104.595 142.505 103.588 142.5 102.486V89.6111H28.5ZM32.8819 21.375H138.118C141.301 21.375 144.015 22.496 146.262 24.738C148.504 26.98 149.625 29.697 149.625 32.889V102.493C149.625 105.676 148.504 108.39 146.262 110.637C144.02 112.879 141.305 114 138.118 114H106.326V144.424L85.5 134L64.6736 144.409V114H32.889C29.697 114 26.98 112.879 24.738 110.637C22.496 108.395 21.375 105.68 21.375 102.493V32.8819C21.375 29.6994 22.496 26.9847 24.738 24.738C26.98 22.496 29.697 21.375 32.889 21.375M28.5 74.2639H142.5V32.889C142.5 31.7918 142.044 30.7847 141.132 29.868C140.22 28.9512 139.215 28.4953 138.118 28.5H32.8819C31.7894 28.5 30.7847 28.956 29.868 29.868C28.9512 30.78 28.4953 31.7846 28.5 32.8819V74.2639ZM28.5 102.493V28.5H32.889C31.7918 28.5 30.7847 28.956 29.868 29.868C28.9512 30.78 28.4953 31.7846 28.5 32.8819V102.493ZM28.5 102.493C28.5 103.586 28.956 104.59 29.868 105.507C30.78 106.424 31.7846 106.88 32.8819 106.875H28.5V102.493Z" fill="#055075" />
  </svg>
);

const CardBackground = () => (
  <>
    <svg
      className="membership-plans__bg-svg-top"
      viewBox="0 0 330 158"
      preserveAspectRatio="none"
    >
      <path
        d="M0 14C0 6.268 6.268 0 14 0H316C323.732 0 330 6.268 330 14V158C218.698 130.837 225.857 49.3122 161.583 68C85.9172 90 0 90 0 14Z"
        fill="#D2F3D0"
      />
    </svg>
    <svg
      className="membership-plans__bg-svg-watermark"
      viewBox="0 0 400 620"
      preserveAspectRatio="none"
    >
      <g transform="translate(200,300)" opacity="0.55">
        <path
          transform="translate(-72,-72) scale(0.84)"
          d="M28.5 89.6111V102.493C28.5 103.586 28.956 104.59 29.868 105.507C30.78 106.424 31.7846 106.88 32.8819 106.875H138.118C139.211 106.875 140.215 106.419 141.132 105.507C142.049 104.595 142.505 103.588 142.5 102.486V89.6111H28.5ZM32.8819 21.375H138.118C141.301 21.375 144.015 22.496 146.262 24.738C148.504 26.98 149.625 29.697 149.625 32.889V102.493C149.625 105.676 148.504 108.39 146.262 110.637C144.02 112.879 141.305 114 138.118 114H106.326V144.424L85.5 134L64.6736 144.409V114H32.889C29.697 114 26.98 112.879 24.738 110.637C22.496 108.395 21.375 105.68 21.375 102.493V32.8819C21.375 29.6994 22.496 26.9847 24.738 24.738C26.98 22.496 29.697 21.375 32.889 21.375M28.5 74.2639H142.5V32.889C142.5 31.7918 142.044 30.7847 141.132 29.868C140.22 28.9512 139.215 28.4953 138.118 28.5H32.8819C31.7894 28.5 30.7847 28.956 29.868 29.868C28.9512 30.78 28.4953 31.7846 28.5 32.8819V74.2639ZM28.5 102.493V28.5H32.889C31.7918 28.5 30.7847 28.956 29.868 29.868C28.9512 30.78 28.4953 31.7846 28.5 32.8819V102.493ZM28.5 102.493C28.5 103.586 28.956 104.59 29.868 105.507C30.78 106.424 31.7846 106.88 32.8819 106.875H28.5V102.493Z"
          fill="#B9DDB7"
        />
      </g>
    </svg>
  </>
);

const MembershipPlans = ({ onEdit, onDelete }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [removingId, setRemovingId] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadPublishedPlans = async () => {
      setLoading(true);
      const { items: fetchedItems, error: fetchError } = await getPublishedMembershipPlanCardItems();
      if (!isMounted) return;
      setItems(fetchedItems);
      setError(fetchError);
      setLoading(false);
    };

    loadPublishedPlans();

    const handleBranchChange = () => {
      loadPublishedPlans();
    };
    window.addEventListener("branchIdChanged", handleBranchChange);

    return () => {
      isMounted = false;
      window.removeEventListener("branchIdChanged", handleBranchChange);
    };
  }, []);

  const total = items.length;

 const handleUnpublish = async (id) => {
  if (removingId) return; 
  setRemovingId(id);

  const { success, error: unpublishError } = await unpublishMembershipPlan(id);

  if (success) {
    setItems((prev) => prev.filter((it) => it.id !== id));
    onDelete && onDelete(id);

    new Toast({
      type: "success",
      duration: 3000,
      message: "Membership plan removed",
    });
  } else {
    setError(unpublishError);

    new Toast({
      type: "error",
      duration: 3000,
      message: unpublishError || "Failed to remove plan",
    });
  }

  setRemovingId(null);
};

  return (
    <div className="membership-plans">
      <CardBackground />

      <div className="membership-plans__header">
        <div className="membership-plans__header-left">
          <CardIcon />
          <p className="membership-plans__title">Active Membership Plans</p>
        </div>
        <span className="membership-plans__badge">{total}</span>
      </div>

      <div className="membership-plans__scroll">
        {loading && <p className="membership-plans__empty">Loading membership plans...</p>}

        {!loading && error && <p className="membership-plans__error">{error}</p>}

        {!loading && !error && items.length === 0 && (
          <p className="membership-plans__empty">No published membership plans yet.</p>
        )}

        {!loading &&
          !error &&
          items.map((it, idx) => (
            <div key={it.id}>
              <div className="membership-plans__item">
                <div className="membership-plans__item-header">
                  <p className="membership-plans__item-name">{it.name}</p>
                  <div className="membership-plans__item-actions">
                    <button
                      className="membership-plans__icon-btn"
                      onClick={() => handleUnpublish(it.id)}
                      disabled={removingId === it.id}
                      aria-label="Remove"
                    >
                      <RemoveIcon />
                      <span className="membership-plans__remove-tooltip">
                        {removingId === it.id ? "Removing..." : "Remove"}
                      </span>
                    </button>
                  </div>
                </div>

                <div className="membership-plans__info-box">
                  <div className="membership-plans__row">
                    <span className="membership-plans__label">Duration</span>
                    <span className="membership-plans__value">{it.duration}</span>
                  </div>

                  {it.sessions != null && (
                    <div className="membership-plans__row">
                      <span className="membership-plans__label">Sessions</span>
                      <span className="membership-plans__value">{it.sessions}</span>
                    </div>
                  )}
                </div>
              </div>

              {idx !== items.length - 1 && <hr className="membership-plans__divider" />}
            </div>
          ))}
      </div>
    </div>
  );
};

export default MembershipPlans;